import { render, staticRenderFns } from "./StudentSpaceInformation.vue?vue&type=template&id=7d950fff&scoped=true"
import script from "./StudentSpaceInformation.vue?vue&type=script&lang=js"
export * from "./StudentSpaceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d950fff",
  null
  
)

export default component.exports